import { createAction } from '@reduxjs/toolkit';

export const REMOVE_STORING_PHONE_NUMBER = 'phone/removeStoringPhoneNumber';

export const removeStoringPhoneNumber = createAction(
    REMOVE_STORING_PHONE_NUMBER,
    () => ({ payload: undefined }),
);
